module.exports = __webpack_public_path__ + "img/female-icon.f896289f.svg";